import {
  SET_ORGANIZATION_LIST,
} from './mutation-type'
import api from '@/api'

const state = {
  organizationList: [],
}

const mutations = {
  [SET_ORGANIZATION_LIST] (state, payload) {
    state.organizationList = payload
  },
}

const actions = {
  // 部门列表
  async getOrganizationList ({commit}) {
    const data = await api.adminApi.queryOrganization()
    if (data.result && data.code === 200) {
      commit(SET_ORGANIZATION_LIST, data.data)
    }
  },
  // 添加部门
  async addOrganization ({dispatch}, payload) {
    const data = await api.adminApi.addOrganization(payload)
    if (data.result && data.code === 200) {
      dispatch('getOrganizationList')
    }
    return data
  },
  // 更新部门
  async updateOrganization ({dispatch}, payload) {
    const data = await api.adminApi.updateOrganization(payload)
    if (data.result && data.code === 200) {
      dispatch('getOrganizationList')
    }
    return data
  },
  // 根据部门id查询管理员
  // eslint-disable-next-line
  async queryAdminByOrganizationId ({}, payload) {
    const data = await api.adminApi.queryAdminByOrganizationId(payload)
    return data
  },
  // 删除部门
  async deleteOrganization ({dispatch}, payload) {
    const data = await api.adminApi.deleteOrganization(payload)
    if (data.result && data.code === 200) {
      dispatch('getOrganizationList')
    }
    return data
  },
  // 验证部门是否已存在
  // eslint-disable-next-line
  async validateOrganizationName ({}, payload) {
    const {result, message, code} = await api.adminApi.validateOrganizationName(payload)
    return {result, message, code}
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
